import styled from "styled-components";

export const CodePanel = styled.section`
  grid-area: code;
  display: flex;
  flex-direction: column;
`;
